import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuMapsetPreviewCss = "mapy-mapmenu-mapset-preview{display:inline-flex;align-items:center;justify-content:center;width:72px;height:48px;overflow:hidden;border-radius:6px;background:lightgray}mapy-mapmenu-mapset-preview img{width:100%;height:100%;object-fit:cover}";

const MapyMapmenuMapsetPreview$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuMapsetPreview extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  static get style() { return mapyMapmenuMapsetPreviewCss; }
}, [4, "mapy-mapmenu-mapset-preview"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-mapset-preview"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-mapset-preview":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuMapsetPreview$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuMapsetPreview = MapyMapmenuMapsetPreview$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuMapsetPreview, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-mapset-preview.js.map